// extracted by mini-css-extract-plugin
var _1 = "Q45eZFcLKPEmeyrrc7rf";
var _2 = "k9D2Ndh2f6tZj9rlzIAc";
var _3 = "KYCnrkNLuG2wXPGVa6_T";
var _4 = "flrJaC10wrRQvdgapx90";
var _5 = "DPd5yBgFaeoIZ2PzG75w";
var _6 = "qEnaSThF5uAQ0ramc0Th";
var _7 = "ymxKIeSspltYHrzAvxpJ";
var _8 = "yp96TDkcapuQSmSO_Jgd";
var _9 = "dlSaKVX6U7RRTx89LUt8";
var _a = "P69Dikbti46obPEou9wT";
var _b = "AR_2lzS309EILn2PiWGC";
var _c = "wbyjBMAjhPA9TnVf50bS";
var _d = "Or7MDNVHgvE3EA4V5kGw";
var _e = "L2oJCMsxttQSDnsIW3yb";
var _f = "SskJpnU3iyMCa1IcbwP3";
var _10 = "jVH1kZnduExi3zGd4Yon";
var _11 = "d8Miac6_kHo3I3TvXtYr";
var _12 = "dqB4WWnjROazkmW9Hk9N";
var _13 = "qhDef5sQQDIcoknpw4Nm";
var _14 = "SjUFmwQnPDV6no3KxszC";
var _15 = "uoRX9vXn8DrZq0uBM4dl";
var _16 = "Ohr1BM_jlePbui2Alz3m";
var _17 = "SbTDpaxWjzmEdwZeJYJ0";
export { _1 as "icon", _2 as "is-128x128", _3 as "is-16x16", _4 as "is-24x24", _5 as "is-32x32", _6 as "is-48x48", _7 as "is-64x64", _8 as "is-96x96", _9 as "large", _a as "medium", _b as "small", _c as "theme-cardiology", _d as "theme-dermatology", _e as "theme-empty", _f as "theme-lab", _10 as "theme-mentalHealth", _11 as "theme-ophthalmology", _12 as "theme-pulmonology", _13 as "theme-referall", _14 as "theme-sleep", _15 as "theme-white-theme", _16 as "theme-xyz", _17 as "xlarge" }
